import { strategicPlanningApi } from "@/api/strategicPlanningApi";
import Breadcrumbs from "@/components/Breadcrumbs";
import Loading from "@/components/feedback/Loading";
import { Box, Button, Container, Pagination, Tab, Tabs, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Outlet, Link as RouterLink, useSearchParams } from "react-router-dom";

const defaultFilter = {
    search: "",
    filter: {},
    page: {
        number: 1,
        size: 15,
    },
    sort: ["name", "-updated"],
};

export default function StrategicPlanningFinderLayout() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [filter, setFilter] = useState(defaultFilter);

    const [refreshGetAllStrategicPlanning, getAllStrategicPlanning] =
        strategicPlanningApi.endpoints.getAllPlan.useLazyQuery();
    const isLoading = getAllStrategicPlanning.isLoading || getAllStrategicPlanning.isFetching;
    const strategicPlannings = getAllStrategicPlanning.data?.data ?? [];
    const total = strategicPlannings?.length ?? "-";

    useEffect(() => {
        refreshGetAllStrategicPlanning(filter);
    }, []);

    return (
        <>
            <Container>
                <Breadcrumbs
                    items={[
                        {
                            label: "Strategic Planning",
                            to: "/workspace/strategic-plannings",
                        },
                    ]}
                />
            </Container>

            <Container>
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                    <Box>
                        <Typography variant="h1" fontSize={34} fontWeight="bold" gutterBottom>
                            Strategic Planning
                        </Typography>
                    </Box>
                    <Box sx={{ marginLeft: "auto" }}>
                        <Button disabled={true} sx={{ textTransform: "none" }}>
                            Search
                        </Button>
                        <Button
                            component={RouterLink}
                            variant="contained"
                            color="primary"
                            to="/workspace/strategic-plannings/new"
                            sx={{ textTransform: "none" }}
                        >
                            New Strategic Planning
                        </Button>
                    </Box>
                </Box>

                <Tabs value={0} sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <Tab
                        label="All"
                        value={0}
                        // sx={{ textTransform: "none", display: "inline-flex" }}
                    />
                </Tabs>
            </Container>

            {/** content */}
            <Container>
                <Box sx={{ marginY: 1 }}>total: {total}</Box>

                {isLoading ? <Loading /> : <Outlet context={{ strategicPlannings }} />}

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: 3,
                    }}
                >
                    <Pagination
                    // showFirstButton
                    // showLastButton
                    // count={Math.ceil(parseInt(kpis?.data?.total) / parseInt(kpis?.data?.per_page) ?? 1)}
                    // count={Math.ceil(parseInt(kpis.data?.meta.total ?? 1) / page.size)}
                    // page={page.number}
                    // onChange={handleOnChangePage}
                    />
                </Box>
            </Container>
        </>
    );
}
